import { createCustomerProductListTypeProductList } from '@ori/global-api-client-react';

import type { ApiProps } from './types';

export const createFavoriteProductsList = async ({ client, customerId }: ApiProps) => {
  const { data } = await createCustomerProductListTypeProductList(client, customerId, 'Favorite', {
    items: [],
  });
  const { items, productListId } = data;

  return { items, productListId };
};
